/**
 * Created by Alex Poh. on 13/03/20.
 * Copyright © 2020 Curriculum Ltd. All rights reserved.
 */

import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { sharedStaticPages } from './shared/components/static-pages/static-pages.routes';

const routes: Routes = [...sharedStaticPages];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
